import { Component, OnInit } from '@angular/core';

import { from, Observable } from 'rxjs';
import { concatMap, map, mergeMap, tap } from 'rxjs/operators';

import { ApplicationNotification, StatusChangeNotification } from 'src/app/model/application-notification';
import { NavigationService } from 'src/app/service/navigation.service';
import { NotificationService } from 'src/app/service/notification-service';

@Component({
    selector: 'notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
    public notifications: ApplicationNotification[] | null;

    constructor(
        private navigationService: NavigationService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void {
        this.navigationService.activity.setupQuickly('Уведомления');
        this.reloadNotificationList().subscribe();
    }

    getType(notification: ApplicationNotification): string {
        if (notification instanceof StatusChangeNotification) {
            return 'STATUS_CHANGE';
        }
        return 'UNKNOWN';
    }

    castToStatusChange(notification: ApplicationNotification): StatusChangeNotification {
        return notification as StatusChangeNotification;
    }

    private reloadNotificationList(): Observable<void> {
        return this.notificationService.list().pipe(
            tap((list) => this.notifications = list),
            concatMap(list => from(list)),
            mergeMap((n) => this.notificationService.markAsRead(n.id ?? '')),
            map(() => void 0)
        );
    }
}
